module.exports = __webpack_public_path__ + "static/media/Platos Vegetarianos.2047a614.svg";